angular.module('project')
    .directive('projectStagingPicker', function (Project) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                required: "=",
                projectId: '=',
                modelType: '=?',
                onChange: "&"
            },
            templateUrl: "app/project/project-staging-picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {
                scope.executeOnChange = scope.onChange || angular.noop
                scope.modelTypeR = scope.modelType || "object"

                scope.refreshData = search => {
                    Project.getStagingItems({id: scope.projectId}).$promise.then(items => scope.items = items);
                }

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => scope.modelTypeR === "id" ? viewValue.id : viewValue);

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                    if (angular.isFunction(scope.executeOnChange())) {
                        scope.executeOnChange()($item)
                    }
                }

            }
        };
    })
